// extracted by mini-css-extract-plugin
module.exports = {"common-service-container":"dd31006766--common-service-container--ZJ4SM"};